import { computed, inject, Injectable, Signal } from '@angular/core';
import { Observable } from 'rxjs';
import { Region } from 'angular-api-gateway/v1/model/region';
import { toObservable } from '@angular/core/rxjs-interop';
import { CityStore } from './city.store';
import { MOSCOW_CENTER } from '@lentau/address/yandex-map/shared/const';

@Injectable({
  providedIn: 'root',
})
export class CityStoreFacade {
  private store: CityStore = inject(CityStore);

  public cityId: Signal<number> = this.store.cityId;
  public cityId$: Observable<number> = toObservable(this.store.cityId);
  public citySlug: Signal<string> = this.store.citySlug;
  public city: Signal<Region> = this.store.city;
  public city$: Observable<Region> = toObservable(this.store.city);
  public cities: Signal<Region[]> = this.store.cities;
  public citiesLoading: Signal<boolean> = this.store.citiesLoading;
  public cities$: Observable<Region[]> = toObservable(this.store.cities);
  public addressRegionId: Signal<number> = this.store.addressRegionId;
  public addressRegionId$: Observable<number> = toObservable(this.addressRegionId);
  public domainRegionId: Signal<number> = this.store.domainRegionId;

  public cityCenter: Signal<number[]> = computed(() => {
    const city: Region = this.city();
    return city?.centerLat && city?.centerLng ? [Number(city?.centerLat), Number(city?.centerLng)] : MOSCOW_CENTER;
  });

  public findCityByDomain$: Observable<Region> = toObservable(
    computed(() => this.cities()?.find((city: Region) => city.id === this.domainRegionId()))
  );

  public getUserRegion(pickupStoreRegionId?: number): void {
    this.store.getUserRegion(pickupStoreRegionId);
  }

  public setCity(city: Region): void {
    if (city) {
      this.store.setCity(city);
    }
  }

  public getCitiesList(): void {
    this.store.getCitiesList();
  }

  public setCitySlug(slug: string): void {
    this.store.setCitySlug(slug);
  }

  public setCityId(cityId: number): void {
    this.store.setCityId(cityId);
  }
}
